import {
    FETCH_PAYMENT_GATEWAY_CREDENTIALS_FAILURE,
    FETCH_PAYMENT_GATEWAY_CREDENTIALS_REQUEST,
    FETCH_PAYMENT_GATEWAY_CREDENTIALS_SUCCESS,
    GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST,
    GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS,
    GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR,
    GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST,
    GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS,
    GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR,
    DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST,
    DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS,
    DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR,
    CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST,
    CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS,
    CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_ERROR,
    RESET_PAYMENT_GATEWAY_CREDENTIAL_CREATE_FORM,
    RESET_PAYMENT_GATEWAY_CREDENTIAL_EDIT_DATA_ON_CREATE_FORM,
    FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_REQUEST,
    FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_SUCCESS,
    FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_ERROR,
    UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST,
    UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS,
    UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_ERROR,
    RESET_PAYMENT_GATEWAY_CREDENTIAL_UPDATE_FORM,
    HIDE_ROLE_LOADER,
    SHOW_ROLE_LOADER,
    FETCH_FORM_DATA_PRICING_SECTION_REQUEST,
    FETCH_FORM_DATA_PRICING_SECTION_FAILED,
    FETCH_FORM_DATA_PRICING_SECTION_SUCCESS,
    CLICKED_CREATE_PAYMENT_CREADENTIAL_FORM
} from './paymentGatewayCredentials.constants';

export const fetchPayementGatewayCredentialsRequest = data => ({
    type: FETCH_PAYMENT_GATEWAY_CREDENTIALS_REQUEST,
    payload: data,
});

export const fetchPayementGatewayCredentialsSuccess = data => ({
    type: FETCH_PAYMENT_GATEWAY_CREDENTIALS_SUCCESS,
    payload: data,
});

export const fetchPayementGatewayCredentialsFailure = error => ({
    type: FETCH_PAYMENT_GATEWAY_CREDENTIALS_FAILURE,
    payload: error,
});

export const fetchPaymentGatewayCredentialDataRequest = payload => ({
    type: FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_REQUEST,
    payload,
});
export const fetchPaymentGatewayCredentialDataSuccess = payload => ({
    type: FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_SUCCESS,
    payload,
});
export const fetchPaymentGatewayCredentialDataError = payload => ({
    type: FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_ERROR,
    payload,
});

export const generatePaymentGatewayCredentialReportRequest = payload => ({
    type: GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST,
    payload,
});
export const generatePaymentGatewayCredentialReportSuccess = payload => ({
    type: GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS,
    payload,
});
export const generatePaymentGatewayCredentialReportError = payload => ({
    type: GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR,
    payload,
});

export const getActivePaymentGatewayCredentialReportRequest = payload => ({
    type: GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST,
    payload,
});
export const getActivePaymentGatewayCredentialReportSuccess = payload => ({
    type: GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS,
    payload,
});
export const getActivePaymentGatewayCredentialReportError = payload => ({
    type: GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR,
    payload,
});

export const downloadPaymentGatewayCredentialReportRequest = payload => ({
    type: DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST,
    payload,
});
export const downloadPaymentGatewayCredentialReportSuccess = payload => ({
    type: DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS,
    payload,
});
export const downloadPaymentGatewayCredentialReportError = payload => ({
    type: DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR,
    payload,
});

export const resetPaymentGatewayCredentialCreateFormData = payload => ({
    type: RESET_PAYMENT_GATEWAY_CREDENTIAL_CREATE_FORM,
    payload,
});

export const resetPaymentGatewayCredentialEditDataOnCreateFormData = payload => ({
    type: RESET_PAYMENT_GATEWAY_CREDENTIAL_EDIT_DATA_ON_CREATE_FORM,
    payload,
});

export const resetPaymentGatewayCredentialUpdateFormData = payload => ({
    type: RESET_PAYMENT_GATEWAY_CREDENTIAL_UPDATE_FORM,
    payload,
});

export const createPaymentGatewayCredentialStepRequest = (
    payload,
    sectionType,
    formSectionData
) => ({
    type: CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST,
    payload,
    sectionType,
    formSectionData,
});

export const createPaymentGatewayCredentialStepSuccess = (
    payload,
    sectionType,
    requestPayload,
    formSectionData
) => ({
    type: CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS,
    payload,
    sectionType,
    requestPayload,
    formSectionData,
});

export const createPaymentGatewayCredentialStepError = (
    payload,
    sectionType
) => ({
    type: CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_ERROR,
    payload,
    sectionType,
});

export const updatePaymentGatewayCredentialStepRequest = (
    payload,
    sectionType,
    formSectionData
) => ({
    type: UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST,
    payload,
    sectionType,
    formSectionData,
});
export const updatePaymentGatewayCredentialStepSuccess = (
    payload,
    sectionType,
    formSectionData
) => ({
    type: UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS,
    payload,
    sectionType,
    formSectionData,
});
export const updatePaymentGatewayCredentialStepError = (
    payload,
    sectionType
) => ({
    type: UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_ERROR,
    payload,
    sectionType,
});

export const showLoader = () => ({ type: SHOW_ROLE_LOADER });
export const hideLoader = () => ({ type: HIDE_ROLE_LOADER });

export const fetchFormDataPricingSectionRequest = payload => ({
    type: FETCH_FORM_DATA_PRICING_SECTION_REQUEST,
    payload
});
export const fetchFormDataPricingSectionSuccess = payload => ({
    type: FETCH_FORM_DATA_PRICING_SECTION_SUCCESS,
    payload
});
export const fetchFormDataPricingSectionFailed = payload => ({
    type: FETCH_FORM_DATA_PRICING_SECTION_FAILED,
    payload
});
export const clickedCreatePaymentCredentialData = payload => ({
    type: CLICKED_CREATE_PAYMENT_CREADENTIAL_FORM,
    payload
})